/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../../components/header/index'
import Hero from '../../components/heros/index'
import Container from '../../components/container'
import Plan from '../../components/plan'
import Item from '../../components/planItem'
import Primary from '../../components/buttons/primary'
import Features from '../../components/features'
import Panel from '../../components/panel'
import CTO from '../../components/cto'
import Footer from '../../components/footer'
import Title from '../../components/title'

const Discord = () => {
    Title('Discord Hosting - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Discord Hosting' description='Get started by selecting a Discord Bot plan below' />
            </div>
            <section className="plans py-28">
                <Container>
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-20 gap-y-16 mb-16">
                        <Plan title='Level 1' price='1.00' renewal='monthly' link='discord-bot/level-1'>
                            <Item title='512 MB DDR4 RAM' />
                            <Item title='10 GB NVMe SSD Storage' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Level 2' price='2.00' renewal='monthly' link='discord-bot/level-2'>
                            <Item title='1 GB DDR4 RAM' />
                            <Item title='25 GB NVMe SSD Storage' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Level 3' price='4.00' renewal='monthly' link='discord-bot/level-3'>
                            <Item title='2 GB DDR4 RAM' />
                            <Item title='50 GB NVMe SSD Storage' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Level 4' price='8.00' renewal='monthly' link='discord-bot/level-4'>
                            <Item title='4 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                    </div>
                    <div className='bg-primary-light shadow-xl p-8 rounded-md text-center'>
                        <h1 className='text-gray-100 font-medium text-2xl mb-2.5'>Unsure what plan is best for you?</h1>
                        <p className='text-gray-300 mb-7'>Contact us and we will help you pick the right choice for your needs.</p>
                        <div className='flex justify-center'>
                            <Primary rounded='sm' arrow={true} length='sm' link='https://billing.stellanode.com/submitticket.php'>Contact Us</Primary>
                        </div>
                    </div>
                </Container>
            </section>
            <Features />
            <Panel />
            <CTO />
            <Footer />
        </main>
    )
}

export default Discord